export default "__VITE_ASSET__C8fKJu0i__"